import { Col, Row, Spin } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAsset } from "../../services/general";
import { patientsService } from "../../services/patient";
import { utils } from '../../utils/messageAlerts';
import HeaderDetail from "./components/HeaderDetail";
import ServiceDetail from "./components/ServiceDetail";

const PatientDetailPage = () => {
  const [loading, setLoading] = useState({
    details: false,
    services: false,
    consents: false,
    admissions: false,
    idCard: false,
    download: false,
    uploadedConsents: false,
  });
  const [patientDetails, setPatientDetails] = useState();
  const [services, setServices] = useState();
  const [admissions, setAdmissions] = useState();
  const [consents, setConsents] = useState();
  const [idCard, setIdCard] = useState();
  const { id } = useParams();

  const fetchPatientDetails = useCallback(async () => {
    setLoading(_loading => ({ ..._loading, details: true }));
    try {
      const [response] = await patientsService.getPatientData({ patientId: id });
      setPatientDetails(response);
    } catch (error) {
      console.error(error);
      utils.messageAlert('error', 'Error al obtener los datos del paciente');
    } finally {
      setLoading(_loading => ({ ..._loading, details: false }));
    }
  }, [id]);

  const fetchPatientIdCard = useCallback(async () => {
    try {
      setLoading(_loading => ({ ..._loading, idCard: true }));
      const response = await getAsset({ id, type: 'Patient', field: 'document' });
      setIdCard(response.document_url);
    } catch (error) {
      console.error(error);
      utils.messageAlert('error', 'Error al obtener la foto de carnet del paciente');
      setIdCard();
    } finally {
      setLoading(_loading => ({ ..._loading, idCard: false }));
    }
  }, [id]);

  const fetchServices = useCallback(async () => {
    setLoading(_loading => ({ ..._loading, services: true }));
    try {
      const response = await patientsService.getPrestations({ patientId: id });
      setServices(response);
    } catch (error) {
      console.error(error);
      utils.messageAlert('error', 'Error al obtener las prestaciones realizadas');
    } finally {
      setLoading(_loading => ({ ..._loading, services: false }));
    }
  }, [id]);

  const fetchAdmissions = useCallback(async () => {
    setLoading(_loading => ({ ..._loading, admissions: true }));
    try {
      const response = await patientsService.getAdmissions({ patientId: id });
      setAdmissions(response);
    } catch (error) {
      console.error(error);
      utils.messageAlert('error', 'Error al obtener las admisiones realizadas');
    } finally {
      setLoading(_loading => ({ ..._loading, admissions: false }));
    }
  }, [id]);

  const fetchConsents = useCallback(async () => {
    setLoading(_loading => ({ ..._loading, consents: true }));
    try {
      const response = await patientsService.getConsentings({ patientId: id });
      setConsents(response);
    } catch (error) {
      console.error(error);
      utils.messageAlert('error', 'Error al obtener los consentiminetos');
    } finally {
      setLoading(_loading => ({ ..._loading, consents: false }));
    }
  }, [id]);

  useEffect(() => {
    fetchPatientDetails();
    fetchPatientIdCard({ id });
    fetchServices();
    fetchConsents();
    fetchAdmissions();
  }, [fetchPatientDetails, fetchPatientIdCard, fetchServices, fetchConsents, id, fetchAdmissions]);

  return (
    <Row justify="center" className="patient-details-wrapper">
      <Col lg={24} xs={24}>
        <Spin
          spinning={loading.details || loading.services || loading.consents}
          className="cmt-spin mt-50"
        >
          {
            !loading.details &&
            <HeaderDetail
              idCard={idCard}
              loading={loading}
              patientDetails={patientDetails}
            />
          }
          {
            !loading.services &&
            <ServiceDetail
              services={services}
              loading={loading}
              setLoading={setLoading}
              patientData={patientDetails}
              admissions={admissions}
              consents={consents}
              fetchConsents={fetchConsents}
              consentsLoading={loading.consents}
            />
          }
        </Spin>
      </Col>
    </Row>
  );
};

export default PatientDetailPage;
